module.exports = __webpack_public_path__ + "img/jiuzhang-back-two@2x.9cee9873.jpg";